export default "__VITE_ASSET__abab8712__"